import type { ParentComponent } from "solid-js";
import { onCleanup, onMount } from "solid-js";
import twelveLogoWithText from "@assets/images/twelve-logo-with-text.svg?url";

/**
 * Mirrors FullPageFormLayoutComponent (ERB) — including its pointer-tracking
 * background gradient — so Inertia auth pages match the ERB sign-in design.
 */
export const AuthPageLayout: ParentComponent = (props) => {
  let gradientRef!: HTMLDivElement;

  onMount(() => {
    let revealed = false;
    const handlePointerMove = (event: PointerEvent) => {
      if (event.pointerType !== "mouse") return;
      if (!revealed) {
        revealed = true;
        gradientRef.classList.remove("opacity-0");
      }
      const percentY = 100 - (event.pageY / window.innerHeight) * 100;
      gradientRef.style.background = `radial-gradient(circle at 33% ${percentY}%, #5149DD22 0%, #5149DD00 50%)`;
    };
    document.addEventListener("pointermove", handlePointerMove);
    onCleanup(() => document.removeEventListener("pointermove", handlePointerMove));
  });

  return (
    <div class="flex min-h-dvh items-center md:items-stretch md:justify-end">
      <div
        ref={gradientRef}
        class="fixed inset-0 z-main-body-background opacity-0 transition-opacity duration-1000 motion-reduce:hidden"
        aria-hidden="true"
      />
      <main class="mx-4 my-6 flex w-full items-center rounded-2xl bg-white p-6 shadow-md-all md:m-0 md:w-2/3 md:rounded-none md:p-15">
        <div class="grow space-y-10 md:max-w-[500px]">
          <img src={twelveLogoWithText} class="h-9 w-auto" alt="Twelve logo" />
          {props.children}
        </div>
      </main>
    </div>
  );
};

/** Footer links to the (still ERB) auth pages — plain anchors, not Inertia links. */
export function AuthPageLink(props: { href: string; children: string }) {
  return (
    <a href={props.href} class="block text-sm text-typography-secondary hover:underline">
      {props.children}
    </a>
  );
}
